"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var debugging = false;
var _default = {
  get enabled() {
    return debugging;
  },

  get disabled() {
    return !debugging;
  },

  get value() {
    return debugging;
  },

  set: function set(value) {
    debugging = !!value;
  },

  set debug(value) {
    debugging = !!value;
  }

};
exports.default = _default;